define('modules/form_editor/views/preview_custom_terms',['require','exports','module','./preview_base','lib/markdown','../../editor/models/editorstate','ldsh!../templates/custom_terms'],function(require,exports,module){
  "use strict";
  var PreviewBase = require("./preview_base"),
      markdown = require("lib/markdown"),
      EditorState = require("../../editor/models/editorstate");

  module.exports = PreviewBase.extend({
    template: require("ldsh!../templates/custom_terms"),

    helpers: function() {
      return {
        termsText: this.getTermsHtml(),
        nameAttr: this.getNameHtml(),
        isAMP: EditorState.getAMPState(),
        ampStateId: this.model.get("ampStateId")
      };
    },

    getTermsHtml: function() {
      var text = this.model.get("termsText");

      if (!text) {
        return '';
      }

      return markdown(text);
    },

    getNameHtml: function() {
      var name = this.model.get("nameAttr");

      if (name) {
        return name;
      }

      var label = this.model.get("labelText");

      if (isNaN(label.slice(-1))) {
        return 'checkbox' + 0;
      }

      return 'checkbox' + label.slice(-1);
    }
  });
});

